<template>
  <div v-if="links.some((el) => el.desc)" class="summary">
    <SidebarTitle :title="title" />
    <div v-for="(item, index) in links" :key="index" class="summary__links">
      <p v-if="item.desc" class="summary__links-title">
        {{ item.title }}
      </p>
      <p
        class="summary__links-desc"
        :class="{
          'summary__links-desc--blue': item.desc === 'Licensing',
          'summary__links-desc--red': item.desc === 'Prohibited',
        }"
      >
        {{ item.desc }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Summary",
  components: {
    SidebarTitle: () => import("./SidebarTitle"),
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    links: {
      type: Array,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.summary {
  margin-bottom: 2.8rem;
  &__links {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 1.6rem;
    margin-bottom: 1rem;
    &:last-of-type {
      margin-bottom: 0;
    }
    &-title {
      font-size: 1.4rem;
      font-weight: 700;
      color: $text;
    }
    &-desc {
      font-size: 1.4rem;
      font-weight: 600;
      color: #75787b;
      &--red {
        color: $red;
      }
      &--blue {
        color: $blue;
      }
    }
  }
}
</style>
